import type { TrackingEventInteraction } from 'common/enums/Reclamation';
import { TrackingEvent, TrackingEventElement } from 'common/enums/Reclamation';
import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';

export const dispatchReclamationRecapCardListEvent = (
  interaction: TrackingEventInteraction,
  element = TrackingEventElement.Icon
) =>
  dispatchTrackingEventGA4({
    event: TrackingEvent.ReclamationRecapCardListClick,
    element,
    interaction,
  });
